import { Component, input, signal } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-loading',
  imports: [NgIf],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css',
})
export class LoadingComponent {
  public readonly isLoading = input<boolean>(false);
  public readonly single = input<boolean>(false);
}
